import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-6 sm:col-4 md:col-3 lg:col-2 xl:col-1" }
const _hoisted_4 = { class: "field col-6 sm:col-4 md:col-3 lg:col-2 xl:col-1" }
const _hoisted_5 = { class: "field col-6 sm:col-2 md:col-3 lg:col-2 xl:col-1" }

import {computed, onMounted, ref, withDefaults} from 'vue'
import {months, MonthType, SelectedMonthType} from "@/components/blocks/Types";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";

type Properties = {
  years?: number[],
  modelValue: SelectedMonthType
}

// Define emits

export default /*#__PURE__*/_defineComponent({
  __name: 'MonthSelector',
  props: {
    years: { default: () => {
    const start = 2020;
    const endDate = (new Date()).getFullYear() + 1;
    return Array.from({length: endDate - start + 1}, (_, i) => start + i);
  } },
    modelValue: null
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit: emits }) {

const props = __props as { years: number[], modelValue: SelectedMonthType };



// Define component property


// Define lifecycle hooks
onMounted(() => {
  formData.value = props.modelValue
})

// Define private property
const formData = ref<SelectedMonthType>({} as SelectedMonthType)

// Define computed values
const computedMonths = computed(() => {
  return months.map((_item, _index) => {
    return {
      index: _index,
      value: _item
    } as MonthType
  })
})


// Define functions
function handleSubmit() {
  emits('change', formData.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleSubmit()), ["prevent"])),
    class: "p-fluid"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Dropdown), {
            modelValue: formData.value.year,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.year) = $event)),
            options: __props.years
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Dropdown), {
            modelValue: formData.value.month,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.month) = $event)),
            optionLabel: "value",
            options: _unref(computedMonths)
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Button), {
            type: "submit",
            label: "Select"
          })
        ])
      ])
    ])
  ], 32))
}
}

})